import _axios from "../../index";
import qs from 'qs'
//子账户列表
export const getChildrenList = data =>
    _axios({
        url: `/account/children/search`,
        method: "get",
        params: data
    });

//创建子账户
export const creatChildren = data =>
    _axios({
        url: '/account/children/create',
        method: "post",
        data,
    });

//更新子账户
export const updateChildren = data =>
    _axios({
        url: '/account/children/update',
        method: "put",
        data,
    });

//禁用子账户
export const disableChildren = data =>
    _axios({
        url: '/account/children/disable',
        method: "put",
        data: qs.stringify(data, { indices: false })
    });

//启用子账户
export const enableChildren = data =>
    _axios({
        url: '/account/children/enable',
        method: "put",
        data: qs.stringify(data, { indices: false })
    });

//删除子账户
export const deleteChildren = data => {
    console.log(qs.stringify(data))
    return (
        _axios({
            url: `/account/children/delete?${qs.stringify(data,{ indices: false })}`,
            method: "delete",
        })
    )
}


//初始化密码
export const initializePassword = data =>
    _axios({
        url: '/account/children/initializePassword',
        method: "put",
        data: qs.stringify(data, { indices: false })
    });

//子账户统计
export const getChildrenOverview = data =>
    _axios({
        url: '/order/children/overview',
        method: "get",
        params: data
    });

//消费时间戳总数
export const getConsumeTsCount = data =>
    _axios({
        url: '/order/consumeTsCount',
        method: "get",
        params: data
    });